import Transportation36Header from "./Header";
import "./index.css";
import Transportation36Table from "./Transportation";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const Transportation36Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="transportation-36-container" id="transportation-36-id">
      <Transportation36Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <Transportation36Table productId={productId} />
        </div>
      )}
    </div>
  );
};

export default Transportation36Components;
